<template>
    <div class="window-wrapper window-new-mail-no-phone">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Для создания письма, пожалуйста, заполните ваш <router-link :to="{name: 'ClientProfile'}">номер телефона</router-link></div>
                    <div class="button-block">
                        <button @click="closeWindow" class="button button-dark button-close-window">ОК</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UserEmptyPhoneWindow",

        methods: {
            closeWindow() {
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            }
        }
    }
</script>

<style scoped>

</style>